import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { BREAKPOINTS } from 'Src/profile-v9/lib/constants';

export const Specialties = styled.p`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  list-style: none;
  margin: 0;
  font-size: ${fromTheme('font_size_heading_4')};
  color: ${fromTheme('color_text')};
  font-weight: ${fromTheme('font_weight_bold')};

  span:not(:last-child)::after {
    content: ',\\00a0';
  }

  @media screen and (min-width: ${BREAKPOINTS.small}px) {
    justify-content: flex-start;
  }
`;
